import { faTimesCircle, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React, { memo } from 'react';

import { Props } from '@/components/AssignedToTask/types';
import { Color } from '@/constants/color';
import Badge from '@/ui/components/Badge';
import formatStaffName from '@/utils/formatStaffName';

const AssignedToTask = ({ item }: Props): JSX.Element => {
  const { assigned_work_group, assigned_user } = item;
  let text;
  let icon;

  if (assigned_user) {
    text = `Assigned to ${formatStaffName({ staff: assigned_user })}`;
    icon = faUser;
  } else {
    if (assigned_work_group) {
      text = `Assigned to ${assigned_work_group.name}`;
      icon = faUsers;
    } else {
      text = 'No assigned user or group';
      icon = faTimesCircle;
    }
  }

  return (
    <span aria-label={text} className="inline-block m-1">
      <Badge
        color={Color.GRAY}
        text={
          <>
            <FontAwesomeIcon className="mr-1" icon={icon} />
            {text}
          </>
        }
      />
    </span>
  );
};

export default memo(AssignedToTask);
